if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

//---------------------product qty range
// document.addEventListener("DOMContentLoaded", function() {
//     function updateActiveVariant() {
//         const urlParams = new URLSearchParams(window.location.search);
//         const variantId = urlParams.get('variant');

//         if (variantId) {
//             // Remove 'active' class from any currently active variant
//             const currentActive = document.querySelector('.inv-progress-bar_id .active');
//             if (currentActive) {
//                 currentActive.classList.remove('active');
//             }

//             // Add 'active' class to the new selected variant
//             const selectedVariantElement = document.querySelector(`#variant-${variantId}`);
//             if (selectedVariantElement) {
//                 selectedVariantElement.classList.add('active');

//                 // Update the stock quantity and progress bar based on the selected variant
//                 const stock = parseInt(selectedVariantElement.dataset.stock);
//                 const variantStock = document.getElementById("variant-stock");
//                 if (variantStock) {
//                     variantStock.innerHTML = stock;

//                     if (isNaN(stock) || stock <= 0) {
//                         document.querySelector(".inv-progress-content").classList.add('hidden');
//                     } else {
//                         document.querySelector(".inv-progress-content").classList.remove('hidden');
//                     }

//                     const progressBarSpan = document.querySelector("#inv-progress-bar span");
//                     switch (stock) {
//                         case 9:
//                             progressBarSpan.style.width = "65%";
//                             break;
//                         case 8:
//                             progressBarSpan.style.width = "60%";
//                             break;
//                         case 7:
//                             progressBarSpan.style.width = "55%";
//                             break;
//                         case 6:
//                             progressBarSpan.style.width = "50%";
//                             break;
//                         case 5:
//                             progressBarSpan.style.width = "40%";
//                             break;
//                         case 4:
//                             progressBarSpan.style.width = "30%";
//                             break;
//                         case 3:
//                             progressBarSpan.style.width = "20%";
//                             break;
//                         case 2:
//                             progressBarSpan.style.width = "10%";
//                             break;
//                         case 1:
//                             progressBarSpan.style.width = "5%";
//                             break;
//                         default:
//                             progressBarSpan.style.width = "90%";
//                             break;
//                     }
//                 }
//             }
//         }
//     }

//     // Initial call to set the active variant based on the initial URL
//     updateActiveVariant();

//     // Listen for changes in the URL
//     window.addEventListener('popstate', updateActiveVariant);
//     window.addEventListener('pushState', updateActiveVariant);
//     window.addEventListener('replaceState', updateActiveVariant);

//     // Override the pushState and replaceState methods to capture URL changes
//     const originalPushState = history.pushState;
//     const originalReplaceState = history.replaceState;

//     history.pushState = function(...args) {
//         originalPushState.apply(history, args);
//         window.dispatchEvent(new Event('pushState'));
//     };

//     history.replaceState = function(...args) {
//         originalReplaceState.apply(history, args);
//         window.dispatchEvent(new Event('replaceState'));
//     };
// });

document.addEventListener("DOMContentLoaded", function() {
    function updateActiveVariant(variantId = null) {
        if (!variantId) {
            const urlParams = new URLSearchParams(window.location.search);
            variantId = urlParams.get('variant');
        }

        if (variantId) {
            // Remove 'active' class from any currently active variant
            const currentActive = document.querySelector('.inv-progress-bar_id .active');
            if (currentActive) {
                currentActive.classList.remove('active');
            }

            // Add 'active' class to the new selected variant
            const selectedVariantElement = document.querySelector(`#variant-${variantId}`);
            if (selectedVariantElement) {
                selectedVariantElement.classList.add('active');

                // Update the stock quantity and progress bar based on the selected variant
                const stock = parseInt(selectedVariantElement.dataset.stock);
                const variantStock = document.getElementById("variant-stock");
                if (variantStock) {
                    variantStock.innerHTML = stock;

                    if (isNaN(stock) || stock <= 0) {
                        document.querySelector(".inv-progress-content").classList.add('hidden');
                    } else {
                        document.querySelector(".inv-progress-content").classList.remove('hidden');
                    }

                    const progressBarSpan = document.querySelector("#inv-progress-bar span");
                    if (stock > 0) {
                        progressBarSpan.style.width = `${Math.min((stock / 10) * 100, 100)}%`;
                    } else {
                        progressBarSpan.style.width = "0%";
                    }
                }
            }
        }
    }

    // Initial call to set the active variant based on the initial URL
    updateActiveVariant();

    // Also handle the case where a variant is already active on page load
    const initialActiveVariant = document.querySelector('.inv-progress-bar_id .active');
    if (initialActiveVariant) {
        const initialActiveVariantId = initialActiveVariant.id.split('-')[1]; // Assumes id is in the format "variant-{id}"
        updateActiveVariant(initialActiveVariantId);
    }

    // Listen for changes in the URL
    window.addEventListener('popstate', () => updateActiveVariant());
    window.addEventListener('pushState', () => updateActiveVariant());
    window.addEventListener('replaceState', () => updateActiveVariant());

    // Override the pushState and replaceState methods to capture URL changes
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    history.pushState = function(...args) {
        originalPushState.apply(history, args);
        window.dispatchEvent(new Event('pushState'));
    };

    history.replaceState = function(...args) {
        originalReplaceState.apply(history, args);
        window.dispatchEvent(new Event('replaceState'));
    };
});

